module.exports = __webpack_public_path__ + "static/media/MC T5.18beeda3.jpeg";